module.exports = __webpack_public_path__ + "img/banner@2x.6d0da682.png";